interface FormatBytesParams {
  bytes: number;
  locale?: string;
  unitDisplay?: Intl.NumberFormatOptions['unitDisplay'];
}

export function formatBytes({
  bytes,
  locale = 'en',
  unitDisplay = 'narrow',
}: FormatBytesParams) {
  if (bytes === 0) {
    return new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'byte',
      unitDisplay,
    }).format(0);
  }

  const k = 1024;
  const units = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);

  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: units[i],
    unitDisplay,
    maximumFractionDigits: 2,
  }).format(value);
}
